import React from 'react';
import { CustomNode } from '@/types/node-types';
import { NodeItem } from './node-list';

interface WorkflowNodeListProps {
  nodes: CustomNode[];
  onNodeSelect: (nodeId: string) => void;
}

export const WorkflowNodeList = React.memo<WorkflowNodeListProps>(
  ({ nodes, onNodeSelect }) => {
    return (
      <div className='flex flex-col h-full overflow-y-auto'>
        <div className='p-4 pb-0'>
          <span className='text-sm font-medium text-foreground'>
            Nodes in Workflow
          </span>
        </div>
        {nodes.length === 0 ? (
          <div className='flex items-center justify-center h-full text-sm text-muted-foreground'>
            No nodes in workflow
          </div>
        ) : (
          <div className='flex flex-col gap-2 p-4'>
            {nodes
              .filter((node) => node.data?.struct)
              .map((node) => {
                const struct = node.data.struct!;

                return (
                  <NodeItem
                    key={node.id}
                    node={struct}
                    onClick={() => onNodeSelect(node.id)}
                    showGripIcon={false}
                  />
                );
              })}
          </div>
        )}
      </div>
    );
  },
);
